import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { CropSettingsManagerComponent } from './crop-settings-manager.component';
import { NameTypesPaneComponent } from './name-types/name-types-pane.component';
import { NameTypeService } from '../shared/name-type/service/name-type.service';
import { NameTypeEditDialogComponent, NameTypeEditPopupComponent } from './name-types/name-type-edit-dialog.component';
import { CROP_SETTINGS_MANAGER_ROUTES } from './crop-settings-manager.route';
import { LocationsPaneComponent } from './locations/locations-pane.component';
import { CropSettingsContext } from './crop-Settings.context';
import { LocationEditDialogComponent, LocationEditPopupComponent } from './locations/location-edit-dialog.component';
import { BreedingMethodsPaneComponent } from './breeding-methods/breeding-methods-pane.component';
import { BreedingMethodEditDialogComponent, BreedingMethodEditPopupComponent } from './breeding-methods/breeding-method-edit-dialog.component';
import { ParametersPaneComponent } from './parameters/parameters-pane.component';
import { LocationService } from '../shared/location/service/location.service';
import { BreedingMethodService } from '../shared/breeding-method/service/breeding-method.service';
import { GermplasmService } from '../shared/germplasm/service/germplasm.service';
import { CropParameterService } from '../shared/crop-parameter/service/crop-parameter.service';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(CROP_SETTINGS_MANAGER_ROUTES),
        HelpLinkComponent
    ],
    declarations: [
        CropSettingsManagerComponent,
        NameTypesPaneComponent,
        LocationsPaneComponent,
        BreedingMethodsPaneComponent,
        NameTypeEditDialogComponent,
        NameTypeEditPopupComponent,
        LocationEditDialogComponent,
        LocationEditPopupComponent,
        BreedingMethodEditDialogComponent,
        BreedingMethodEditPopupComponent,
        ParametersPaneComponent
    ],
    providers: [
        NameTypeService,
        LocationService,
        BreedingMethodService,
        GermplasmService,
        CropParameterService,
        CropSettingsContext
    ]
})
export class CropSettingsManagerModule {

}
